module.exports = __webpack_public_path__ + "img/ups.3ba76d70.png";